import React from 'react'
import { Container, Card, Row } from 'react-bootstrap'
import { formatCurrency, formatDateToString } from 'application/helpers'
import * as E from '../pdf/pdfElements'

interface ICustomerRowItemProps {
  hideIfNoValue?: boolean
  title: string
  value: string | null
}

const CustomerRowItem = (props: ICustomerRowItemProps) => {
  if (
    props.hideIfNoValue &&
    (props.value === null || props.value.trim() === '')
  )
    return <></>

  return (
    <>
      <Row>
        <E.CardValueHeading
          xs={4}
          md={4}
          id={'customerrow.title_' + props.title}
        >
          {props.title}
        </E.CardValueHeading>

        <E.CardValueValue xs={8} md={8} id={'customerrow.value_' + props.title}>
          {props.value}
        </E.CardValueValue>
      </Row>
    </>
  )
}

interface IProposalCustomerSectionProps {
  pdf: boolean
  isProposal: boolean
  proposalNumber: string
  dateOfProposalAcceptance: Date
  title: string
  data: {
    lastName: string
    firstName: string
    address1Line1: string
    address1Line2: string
    address1City: string
    address1State: string
    address1PostCode: string
    email: string
    mobile: string
    employer: { grossAnnualSalary: number; name: string; payrollId: string }
  }
}

const CustomerSection = (props: IProposalCustomerSectionProps) => {
  let userName = props.data
    ? props.data.firstName + ' ' + props.data.lastName
    : ''
  let getAddress = () => {
    let address = ''
    if (props.data) {
      if (props.data.address1Line1) {
        address = address + ' ' + props.data.address1Line1
      }
      if (props.data.address1Line2) {
        address = address + ' ' + props.data.address1Line2
      }
      if (props.data.address1City) {
        address = address + ' ' + props.data.address1City
      }
      if (props.data.address1State) {
        address = address + ' ' + props.data.address1State
      }
      if (props.data.address1PostCode) {
        address = address + ' ' + props.data.address1PostCode
      }
    }
    return address
  }

  return (
    <div className="card-section">
      <Container className="section mt-4">
        {props.data && (
          <E.StyledCard>
            <E.StyledCardHeader>
              <E.StyledCardHeaderText>{props.title}</E.StyledCardHeaderText>
            </E.StyledCardHeader>
            <Card.Body>
              <CustomerRowItem title="Name" value={userName} hideIfNoValue />
              <CustomerRowItem
                title="Email"
                value={props.data.email}
                hideIfNoValue
              />
              <CustomerRowItem
                title="Mobile"
                value={props.data.mobile}
                hideIfNoValue
              />
              {props.isProposal && props.proposalNumber && (
                <>
                  <CustomerRowItem
                    title="Proposal Number"
                    value={props.proposalNumber}
                    hideIfNoValue
                  />
                </>
              )}

              {props.data.employer && (
                <>
                  <CustomerRowItem
                    title="Annual Salary"
                    value={formatCurrency(
                      props.data.employer.grossAnnualSalary
                    )}
                    hideIfNoValue
                  />
                  <CustomerRowItem
                    title="Employer"
                    value={props.data.employer.name}
                    hideIfNoValue
                  />
                </>
              )}
              <CustomerRowItem
                title="Date of Acceptance"
                value={formatDateToString(
                  props.dateOfProposalAcceptance,
                  ' '
                )}
                hideIfNoValue
              />
              <CustomerRowItem
                title="Home address"
                value={getAddress()}
                hideIfNoValue
              />
              {props.data.employer && (
                <CustomerRowItem
                  title="Payroll ID"
                  value={props.data.employer.payrollId}
                  hideIfNoValue
                />
              )}
            </Card.Body>
          </E.StyledCard>
        )}
      </Container>
    </div>
  )
}

export default CustomerSection
